import { render, staticRenderFns } from "./watchlist-button.vue?vue&type=template&id=465b3857&"
import script from "./watchlist-button.vue?vue&type=script&setup=true&lang=js&"
export * from "./watchlist-button.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./watchlist-button.vue?vue&type=style&index=0&id=465b3857&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports